// extracted by mini-css-extract-plugin
export var emptyState = "_6c-d";
export var statCard = "_6c-c";
export var table = "_6c-0";
export var tableCell = "_6c-4";
export var tableCellClickable = "_6c-5 _6c-4";
export var tableCellDefault = "_6c-6 _6c-4";
export var tableCellEmpty = "_6c-8";
export var tableCellWithValue = "_6c-7";
export var tableContainer = "_6c-e";
export var tableHeaderWeight = "_6c-1";
export var tableHeaderZone = "_6c-2";
export var tableRowHeader = "_6c-3";
export var viewModeButton = "_6c-9";
export var viewModeButtonActive = "_6c-a _6c-9";
export var viewModeButtonInactive = "_6c-b _6c-9";